import { useContext } from 'react';
import { FrontendSettingsContext } from './useFrontendSettings';

type InferFromType<TType> = TType extends boolean
    ? boolean
    : TType extends string
      ? string
      : TType extends string[]
        ? string[]
        : undefined;

export function useFeatureFlag<TValue extends string | boolean | string[] | undefined>(
    featureFlag: string,
    defaultValue: TValue
) {
    const context = useContext(FrontendSettingsContext);

    if (!context) {
        throw new Error('useFeatureFlag must be used within a FrontendSettingsProvider');
    }

    return (context.frontendSettings.featureFlags[featureFlag] ?? defaultValue) as InferFromType<TValue>;
}
